import { render, staticRenderFns } from "./editBankData.vue?vue&type=template&id=b2c7f332&scoped=true"
import script from "./editBankData.vue?vue&type=script&lang=ts"
export * from "./editBankData.vue?vue&type=script&lang=ts"
import style0 from "./editBankData.vue?vue&type=style&index=0&id=b2c7f332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c7f332",
  null
  
)

export default component.exports